"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountUpdateDto = void 0;
const discount_coupon_1 = require("../discount.coupon");
const misc_1 = require("../../../misc");
class DiscountUpdateDto extends (0, misc_1.generateUpdateDto)(discount_coupon_1.DiscountCoupon, ['title', 'code', 'amount', 'endDate', 'perUserLimit', 'totalUsageLimit']) {
}
exports.DiscountUpdateDto = DiscountUpdateDto;
